import React, { useState, useEffect, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getWarehouseByEstablishment, getWarehouseItemList, getWarehouseItemTransferList, warehouseItemTransferReception } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { setRequireCloseModal, setWarehouseItemTransferList } from '../../../../slices/warehouseItemTransfer/reducer';
import ConfirmReceptionItemModal from '../../PPE/Item/Modals/ConfirmReceptionItemModal';
import TransferFilesModal from '../../PPE/Transfers/Modals/TransferFilesModal';

const ReceptionItemModal = ({
    isOpen,
    handleToggleModal,
    establishmentId
}) => {
    const dispatch = useDispatch();
    const [dataItem, setDataItem] = useState(null);
    const [list, setList] = useState(null);
    const [listItemsSelectedToReception, setListItemsSelectedToReception] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalConfirmReception, setModalConfirmReception] = useState(false);
    const [modalTransferFiles, setModalTransferFiles] = useState(false);

    const selectorItems = createSelector(
        state => state.WarehouseItemTransfers,
        data => ({
            warehouseItemList: data.warehouseItemList,
            isLoadingList: data.isLoadingList,
            requireCloseModal: data.requireCloseModal,
            isReception: data.isReception,
            isReceived: data.isReceived,
            isReceptionError: data.isReceptionError
        })
    );

    const {
        warehouseItemList,
        isLoadingList,
        requireCloseModal,
        isReception,
        isReceived,
        isReceptionError
    } = useSelector(selectorItems);

    // Update Data
	const handleClickEdit = data => {
		setDataItem(data);
		handleToggleModal();
	};

    const [selectionReceiveList, setSelectionReceiveList] = useState([]);
    const [selectionToReceivedList, setSelectionToReceivedList] = useState([]);

    function handleRemoveGuideSelectionList(guide) {
        let selectionReceiveListToUpdate = selectionReceiveList;
        delete selectionReceiveListToUpdate[guide._id];
        setSelectionReceiveList(selectionReceiveListToUpdate);
        setGuideSelectedList(guideSelectedList.filter(item => item._id != guide._id));
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
        },
        validationSchema: Yup.object({
        }),
        onSubmit: async values => {
            setLoading(true);

            console.log(listItemsSelectedToReception)

            // Validar que haya al menos un ítem seleccionado
            if (listItemsSelectedToReception?.length === 0) {
                toast.error('Debe seleccionar al menos un ítem para recepcionar.');
                setLoading(false);
                return;
            }

            const formData = {
                establishment_id: establishmentId,
                items: listItemsSelectedToReception
            }

            try {
                await dispatch(warehouseItemTransferReception(formData))
                dispatch(getWarehouseItemList({ establishment_id: establishmentId }));
                setSelectionReceiveList([]);
                setLoading(false);
                dispatch(setRequireCloseModal(true));
                handleToggleModal();


            } catch (err) {
                console.error('Error al guardar:', err);
                toast.error('Hubo un error al guardar la información');
            }
        }
    });

    function handleToggleModalTransferFiles(data) {
        setDataItem(data)
		setModalTransferFiles(
			!modalTransferFiles
		);
	}

    useEffect(() => {
        console.log('cambió', selectionReceiveList)
        if (isOpen, selectionReceiveList) {
            let selectionItems = [];
            Object.entries(selectionReceiveList).forEach(([key, value]) => {
                if (key != null) {
                    selectionItems.push(key);
                }
            })
            setListItemsSelectedToReception(selectionItems);
        }
    }, [selectionReceiveList])

    useEffect(() => {
        if(isOpen){
            dispatch(setWarehouseItemTransferList([]))
            dispatch(getWarehouseItemTransferList({
                establishment_id: establishmentId,
                warehouse_usage_type_code: 'EPP',
                received: false
            }));
        }
       
    }, [isOpen, establishmentId]);

    useEffect(() => {
        if(!isLoadingList){
            setList(warehouseItemList);
        }
    }, [warehouseItemList, isLoadingList])

    useEffect(() => {
        if (isOpen) {
            if (requireCloseModal) {
                dispatch(setRequireCloseModal(false));
                dispatch(getWarehouseItemList({ establishment_id: establishmentId }));
                handleToggleModal();
            }
        }
    }, [requireCloseModal]);

    const columns = useMemo(
        () => [
            {
                header: 'Acciones',
                enableSorting: false,
                enableColumnFilter: false,
                enableGlobalFilter: false,
                enableColumnActions: false,
                accessorKey: 'categories',
                columnDefType: 'display',
                width: '3%',
                Cell: cellProps => {
                    const transfer = cellProps.row.original;

                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        {(
                                            <li className='list-inline-item'>
                                                <Link
                                                    to='#'
                                                    onClick={() => {
                                                        handleToggleModalTransferFiles(
                                                            transfer
                                                        );
                                                    }}
                                                    title='Ver Documentos'
                                                >
                                                    <i className='ri-file-search-line align-bottom me-2 text-muted'></i>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            { header: 'Nombre', accessorKey: 'warehouse_item.name', size: 'auto' },
            { header: 'Código', accessorKey: 'warehouse_item.code_sap', size: 'auto' },
            { header: 'Cantidad', accessorKey: 'quantity', size: 'auto', summary: true, type: 'separator' },
            { header: 'Bodega de Origen', accessorKey: 'warehouse_origin.name', size: 'auto' },
            { header: 'Bodega de Destino', accessorKey: 'warehouse_destination.name', size: 'auto' },
        ],
        [handleClickEdit]
    );

    return (
        <React.Fragment>
            <ConfirmReceptionItemModal
                isOpen={modalConfirmReception}
                onToggle={() => setModalConfirmReception(!modalConfirmReception)}
                onSubmit={() => {
                    setModalConfirmReception(!modalConfirmReception)
                    validation.submitForm()
                }}
            />
            <Modal
                isOpen={isOpen}
                toggle={handleToggleModal}
                size='xl'
                className='border-0'
                modalClassName='modal fade zoomIn'
                backdrop={'static'}
                centered={true}
            >
                <ModalHeader toggle={handleToggleModal}>
                    Recepción de Items
                </ModalHeader>
                <ModalBody>
                    <ODataGrid
                        columns={columns}
                        data={list || []}
                        getRowIdTable={(originalRow) => originalRow._id}
                        selectAllMode={'all'}
                        selection={{
                            rowSelection: selectionReceiveList,
                            setRowSelection: setSelectionReceiveList,
                        }}
                        isLoadingData={false}
                    />
                    <div className='w-100 d-flex flex-row-reverse gap-2 mt-4'>
                        <button
                            className='btn btn-label btn-primary'
                            onClick={() => {
                                if (listItemsSelectedToReception?.length === 0) {
                                    toast.error('Debe seleccionar al menos un ítem para recepcionar.');
                                    setLoading(false);
                                    return;
                                }
                                setModalConfirmReception(true);
                            }}
                            disabled={loading || isReception}
                        >
                            <i className={`${Icons.check} label-icon`}></i>{' '}
                            Recepcionar
                        </button>
                    </div>
                </ModalBody>
                

            </Modal>
            <TransferFilesModal
				dataTransfer={dataItem}
				isOpen={modalTransferFiles}
				handleToggleModal={
					handleToggleModalTransferFiles
				}
			/>

        </React.Fragment>
    );
};

export default ReceptionItemModal;
